import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';

const Contact = () => {
    const form = useRef();
    const sendEmail = event => {
        event.preventDefault();
        emailjs.sendForm('service_t3kj1nn', 'template_v3h354g', form.current, 'pjevYaXDMI4uNLUlq')
            .then((result) => {
                toast('Message sent')
                event.target.reset()
            }, (error) => {
                toast.error('something worng!')
            });

    }
    return (
        <div id='contact' className='bg-[#ffb403] mt-40 py-10 text-black lg:px-20 z-50'>
            <h1 className='text-center text-4xl font-bold text-black mb-10'>Contact <span className='text-white w-fit border-0 border-b-2  border-black' >Me</span></h1>

            <div className="flex flex-col lg:flex-row contact gap-40">
                <div className="basis-1/2">
                    <h1 className='text-3xl font-semibold mb-10 w-fit border-0 border-b-2  border-black'>Let's get in touch</h1>
                    <p className=' text-lg font-semibold mb-10'>I enjoy discussing new projects and design challenges. <br />
                        Please share as much info, as possible so we can get <br /> the most out of our first catch-up. </p>
                    <div>
                        <h2 className='text-xl font-semibold'>Living In:</h2>
                        <p className='text-xl mb-10'>#D, Estern Housing, Pallabi, Mirpur, Dhaka.</p>
                    </div>
                    <div>
                        <h2 className='text-xl font-semibold'>Call:</h2>
                        <p className='text-xl '>+8801878538321 </p>
                    </div>
                </div>


                <div className="basis-1/2">

                    <form ref={form} onSubmit={sendEmail} className='lg:pr-20'>

                        <div class="mb-6">
                            <label for="base-input" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Your Name</label>
                            <input name="user_name" type="text" id="base-input" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                        </div>
                        <div class="mb-6">
                            <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Your email</label>
                            <input type="email" name="user_email" id="email" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="your@email.com" required="" />
                        </div>

                        <div class="mb-6">
                            <label for="base-input" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Subject</label>
                            <input type="text" name="email_subject" id="base-input" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="type?" />
                        </div>

                        <label for="message" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">Your message</label>
                        <textarea id="message" name="message" rows="4" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Estimate your Project?"></textarea>



                        <button type="submit" class="mt-5 text-white bg-accent hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Send</button>
                    </form>




                </div>
            </div>
        </div>
    );
};

export default Contact;